import { createAction } from '@reduxjs/toolkit';

export const setActiveNavKey = createAction<string>('setActiveNavKey');
